import { z } from 'zod'
import { zfd } from 'zod-form-data'

const ISO_DATE = /^\d{4}-\d{2}-\d{2}$/

// Windows browsers commonly report a `.csv` as `application/vnd.ms-excel`.
const initiativeCsvFile = zfd
  .file()
  .refine((file) => ['text/csv', 'application/vnd.ms-excel'].includes(file.type), {
    message: 'Invalid document file type',
  })

export const parseInitiativeFileSchema = zfd.formData({ file: initiativeCsvFile })

/** The file rides along with the metadata: the server re-parses rather than trusting the client. */
export const createInitiativeFormSchema = zfd.formData({
  name: zfd.text(z.string().trim().min(1).max(200)),
  startDate: zfd.text(z.string().regex(ISO_DATE)),
  endDate: zfd.text(z.string().regex(ISO_DATE)),
  file: initiativeCsvFile,
})
